import React, { memo, useCallback, useState } from "react";
import { connect } from "react-redux";
import "moment-timezone";
import NumberFormat from "react-number-format";
import { withTranslation } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";

import Images from "../../../constants/lotto5Images";
import Printer from "../../print/Printer";
import TicketDetail from "../TicketDetail";
import RefreshButton from "../../../utils/RefreshButton";
import { moneyFormatter } from "../../../utils/MoneyUtils";

import {
    fetchRouletteRecentBetReport,
    fetchRouletteDrawingResult,
    getRecentSize,
    setRecentSize,
} from "../../../store/rootAction";

const RecentBetting = (props) => {
    const {
        t,
        afterPrint,
        recentBetting = [],
        user,
        fetchRouletteRecentBetReport,
    } = props;

    const [isShowRecentBet, setIsShowRecentBet] = useState(false);
    const [recentBetDetail, setRecentBetDetail] = useState(null);
    const [size, setSize] = useState(getRecentSize().roulette);
    const [imageRotate, setImageRotate] = useState("");

    const currencyCode = user?.userBalance?.currencyCode;

    const onShowDetail = useCallback((item) => {
        setIsShowRecentBet(true);
        setRecentBetDetail(item);
    }, []);

    const onCloseDetail = useCallback(() => {
        setIsShowRecentBet(false);
        setRecentBetDetail(null);
    }, []);

    const onChangeSize = useCallback((nextSize) => {
        setSize(nextSize);
        setRecentSize({ roulette: nextSize });
    }, []);

    const getRecentBetting = useCallback(() => {
        setImageRotate("rotate");

        Promise.resolve(fetchRouletteRecentBetReport())
            .finally(() => {
                setTimeout(() => {
                    setImageRotate("");
                }, 300);
            });
    }, [fetchRouletteRecentBetReport]);

    const handleSizeBlur = useCallback(() => {
        if (size > 0 && size < 11) {
            getRecentBetting();
        } else {
            onChangeSize(3);
        }
    }, [size, getRecentBetting, onChangeSize]);

    if (!recentBetting) {
        return null;
    }

    return (
        <div>
            <div>
                <div className="col no-padding-div header-div-title header-text header-div-blue-light block-header">
          <span className="text-black kh-font-bold">
            {t("labels:common.recentBet")}
              <NumberFormat
                  className="in-recent-size"
                  isAllowed={({ value }) => value < 11}
                  onBlur={handleSizeBlur}
                  onValueChange={({ floatValue }) => onChangeSize(floatValue)}
                  value={size}
              />
            <span>{t("labels:common.draw")}</span>
          </span>

                    <RefreshButton
                        onClick={getRecentBetting}
                        className={imageRotate}
                    />
                </div>

                <div className="table-responsive dashboard-fix-height header-div-white fade-in">
                    <table className="table table-current-bet">
                        <tbody className="header-div-white">
                        {recentBetting.map((item, i) => (
                            <React.Fragment key={item?.drawCode || item?.drawLabel || i}>
                                <tr className="draw-header-bg">
                                    <td
                                        className="text-left draw-code-recent-bet dashboard-padding-left"
                                        colSpan={7}
                                    >
                                        {item.drawLabel}
                                    </td>
                                </tr>

                                {item.tickets?.map((row, k) => {
                                    const items = row?.items || [];

                                    return (
                                        <tr
                                            key={row?.ticketCode || k}
                                            className="table-recent-betting"
                                        >
                                            <td colSpan={3} className="text-center">
                                                <div className="header-draw">
                                                    <div
                                                        className="text-left ticket-code-recent-bet text-primary"
                                                        onClick={() => onShowDetail(row)}
                                                    >
                                                        {row.ticketCode}
                                                    </div>

                                                    <div>
                                                        {row?.winAmount > 0 || row?.bonusAmount > 0 || !row?.status ? (
                                                            <Printer
                                                                data={row}
                                                                lottoType="ROULETTE"
                                                                {...props}
                                                                afterPrint={afterPrint}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>

                                                {items.map((e, index) => {
                                                    const isNum = !_.isNaN(parseInt(e?.betCode, 10));
                                                    const betCode = isNum
                                                        ? e?.betCode
                                                        : t(`labels:drawing.drawPrefix.${e?.betCode}`);

                                                    return (
                                                        <div
                                                            key={`${e?.betCode || index}-${index}`}
                                                            className="d-flex justify-content-start text-center"
                                                        >
                                                            <div className="w-25">{betCode}</div>

                                                            <NumberFormat
                                                                value={e?.betAmount}
                                                                displayType="text"
                                                                thousandSeparator
                                                                suffix=" "
                                                            />

                                                            <div className="pl-1 pr-1">X</div>
                                                            <div>{e?.betValue}</div>
                                                            <div className="pl-1 pr-1">=</div>

                                                            {!row?.status ? (
                                                                <span className="text-danger">???</span>
                                                            ) : e?.winAmount <= 0 ? (
                                                                <span className="text-danger">0</span>
                                                            ) : (
                                                                <span>
                                    {moneyFormatter(
                                        e?.winAmount,
                                        currencyCode,
                                        "text-primary"
                                    )}
                                  </span>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                                {items.length > 1 && (
                                                    <div className="text-left d-flex">
                                                        <div className="w-25 text-center">
                                                            {t("labels:recentBet.sub_total")}
                                                        </div>

                                                        <span>
                                {moneyFormatter(row?.betAmount, row?.currencyCode)} /{" "}
                                                            {!row?.status ? (
                                                                <span className="text-danger">???</span>
                                                            ) : (
                                                                moneyFormatter(
                                                                    row?.winAmount,
                                                                    row?.currencyCode,
                                                                    "text-primary"
                                                                )
                                                            )}
                              </span>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>

                    {recentBetting.length === 0 ? (
                        <img
                            className="data-not-found"
                            src={Images.dataNotFound}
                            alt="No data found"
                        />
                    ) : null}
                </div>
            </div>

            <SweetAlert
                title=" "
                show={isShowRecentBet}
                onConfirm={onCloseDetail}
                confirmBtnText={t("labels:common.close")}
                showCancel={false}
                btnSize="lg"
            >
                <TicketDetail dataDetail={recentBetDetail} />
            </SweetAlert>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    recentBetting: state.roulette.drawing.recentBetting,
});

const mapDispatchToProps = {
    fetchRouletteDrawingResult,
    fetchRouletteRecentBetReport,
};

export default withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(memo(RecentBetting))
);